import { render, staticRenderFns } from "./FormularioSeguro.vue?vue&type=template&id=23c5e019&scoped=true&"
import script from "./FormularioSeguro.vue?vue&type=script&lang=js&"
export * from "./FormularioSeguro.vue?vue&type=script&lang=js&"
import style0 from "./FormularioSeguro.vue?vue&type=style&index=0&id=23c5e019&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5e019",
  null
  
)

export default component.exports